import logo from '../assets/logo.png';
import s from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={s.footer}>
      <div className={s.inner}>
        <a href="#" className={s.logo}>
          <img src={logo} alt="Next IT Era" className={s.logoImg} />
        </a>
        <nav className={s.links}>
          {['Services','About','Team','Contact'].map(l => (
            <a key={l} href={`#${l.toLowerCase()}`} className={s.link}>{l}</a>
          ))}
        </nav>
        <p className={s.copy}>© {new Date().getFullYear()} Next IT Era · Dubai, UAE</p>
      </div>
    </footer>
  );
}
